module.exports = __webpack_public_path__ + "static/media/action-adult-analog-1043512.712c7484.jpg";